/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GestorRouteImport } from './routes/gestor'
import { Route as GestorIndexRouteImport } from './routes/gestor.index'
import { Route as GestorAcessosRouteImport } from './routes/gestor.acessos'
import { Route as GestorCamadasRouteImport } from './routes/gestor.camadas'
import { Route as GestorCargosRouteImport } from './routes/gestor.cargos'
import { Route as GestorConfirmarEmailRouteImport } from './routes/gestor.confirmar-email'
import { Route as GestorContaRouteImport } from './routes/gestor.conta'
import { Route as GestorConteudosRouteImport } from './routes/gestor.conteudos'
import { Route as GestorEsqueciSenhaRouteImport } from './routes/gestor.esqueci-senha'
import { Route as GestorHistoricoRouteImport } from './routes/gestor.historico'
import { Route as GestorNovaSenhaRouteImport } from './routes/gestor.nova-senha'
import { Route as GestorPainelRouteImport } from './routes/gestor.painel'
import { Route as GestorSenhaRouteImport } from './routes/gestor.senha'
import { Route as GestorEsqueciSenhaCodigoRouteImport } from './routes/gestor.esqueci-senha.codigo'
import { Route as GestorIndicacaoCancelarRouteImport } from './routes/gestor.indicacao.cancelar'
import { Route as GestorIndicacaoConfirmarRouteImport } from './routes/gestor.indicacao.confirmar'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GestorRoute = GestorRouteImport.update({
  id: '/gestor',
  path: '/gestor',
  getParentRoute: () => rootRouteImport,
} as any)
const GestorIndexRoute = GestorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GestorRoute,
} as any)
const GestorAcessosRoute = GestorAcessosRouteImport.update({
  id: '/acessos',
  path: '/acessos',
  getParentRoute: () => GestorRoute,
} as any)
const GestorCamadasRoute = GestorCamadasRouteImport.update({
  id: '/camadas',
  path: '/camadas',
  getParentRoute: () => GestorRoute,
} as any)
const GestorCargosRoute = GestorCargosRouteImport.update({
  id: '/cargos',
  path: '/cargos',
  getParentRoute: () => GestorRoute,
} as any)
const GestorConfirmarEmailRoute = GestorConfirmarEmailRouteImport.update({
  id: '/confirmar-email',
  path: '/confirmar-email',
  getParentRoute: () => GestorRoute,
} as any)
const GestorContaRoute = GestorContaRouteImport.update({
  id: '/conta',
  path: '/conta',
  getParentRoute: () => GestorRoute,
} as any)
const GestorConteudosRoute = GestorConteudosRouteImport.update({
  id: '/conteudos',
  path: '/conteudos',
  getParentRoute: () => GestorRoute,
} as any)
const GestorEsqueciSenhaRoute = GestorEsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => GestorRoute,
} as any)
const GestorHistoricoRoute = GestorHistoricoRouteImport.update({
  id: '/historico',
  path: '/historico',
  getParentRoute: () => GestorRoute,
} as any)
const GestorNovaSenhaRoute = GestorNovaSenhaRouteImport.update({
  id: '/nova-senha',
  path: '/nova-senha',
  getParentRoute: () => GestorRoute,
} as any)
const GestorPainelRoute = GestorPainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => GestorRoute,
} as any)
const GestorSenhaRoute = GestorSenhaRouteImport.update({
  id: '/senha',
  path: '/senha',
  getParentRoute: () => GestorRoute,
} as any)
const GestorEsqueciSenhaCodigoRoute =
  GestorEsqueciSenhaCodigoRouteImport.update({
    id: '/codigo',
    path: '/codigo',
    getParentRoute: () => GestorEsqueciSenhaRoute,
  } as any)
const GestorIndicacaoCancelarRoute = GestorIndicacaoCancelarRouteImport.update({
  id: '/indicacao/cancelar',
  path: '/indicacao/cancelar',
  getParentRoute: () => GestorRoute,
} as any)
const GestorIndicacaoConfirmarRoute =
  GestorIndicacaoConfirmarRouteImport.update({
    id: '/indicacao/confirmar',
    path: '/indicacao/confirmar',
    getParentRoute: () => GestorRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/gestor': typeof GestorRouteWithChildren
  '/gestor/acessos': typeof GestorAcessosRoute
  '/gestor/camadas': typeof GestorCamadasRoute
  '/gestor/cargos': typeof GestorCargosRoute
  '/gestor/confirmar-email': typeof GestorConfirmarEmailRoute
  '/gestor/conta': typeof GestorContaRoute
  '/gestor/conteudos': typeof GestorConteudosRoute
  '/gestor/esqueci-senha': typeof GestorEsqueciSenhaRouteWithChildren
  '/gestor/historico': typeof GestorHistoricoRoute
  '/gestor/nova-senha': typeof GestorNovaSenhaRoute
  '/gestor/painel': typeof GestorPainelRoute
  '/gestor/senha': typeof GestorSenhaRoute
  '/gestor/': typeof GestorIndexRoute
  '/gestor/esqueci-senha/codigo': typeof GestorEsqueciSenhaCodigoRoute
  '/gestor/indicacao/cancelar': typeof GestorIndicacaoCancelarRoute
  '/gestor/indicacao/confirmar': typeof GestorIndicacaoConfirmarRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gestor/acessos': typeof GestorAcessosRoute
  '/gestor/camadas': typeof GestorCamadasRoute
  '/gestor/cargos': typeof GestorCargosRoute
  '/gestor/confirmar-email': typeof GestorConfirmarEmailRoute
  '/gestor/conta': typeof GestorContaRoute
  '/gestor/conteudos': typeof GestorConteudosRoute
  '/gestor/esqueci-senha': typeof GestorEsqueciSenhaRouteWithChildren
  '/gestor/historico': typeof GestorHistoricoRoute
  '/gestor/nova-senha': typeof GestorNovaSenhaRoute
  '/gestor/painel': typeof GestorPainelRoute
  '/gestor/senha': typeof GestorSenhaRoute
  '/gestor': typeof GestorIndexRoute
  '/gestor/esqueci-senha/codigo': typeof GestorEsqueciSenhaCodigoRoute
  '/gestor/indicacao/cancelar': typeof GestorIndicacaoCancelarRoute
  '/gestor/indicacao/confirmar': typeof GestorIndicacaoConfirmarRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/gestor': typeof GestorRouteWithChildren
  '/gestor/acessos': typeof GestorAcessosRoute
  '/gestor/camadas': typeof GestorCamadasRoute
  '/gestor/cargos': typeof GestorCargosRoute
  '/gestor/confirmar-email': typeof GestorConfirmarEmailRoute
  '/gestor/conta': typeof GestorContaRoute
  '/gestor/conteudos': typeof GestorConteudosRoute
  '/gestor/esqueci-senha': typeof GestorEsqueciSenhaRouteWithChildren
  '/gestor/historico': typeof GestorHistoricoRoute
  '/gestor/nova-senha': typeof GestorNovaSenhaRoute
  '/gestor/painel': typeof GestorPainelRoute
  '/gestor/senha': typeof GestorSenhaRoute
  '/gestor/': typeof GestorIndexRoute
  '/gestor/esqueci-senha/codigo': typeof GestorEsqueciSenhaCodigoRoute
  '/gestor/indicacao/cancelar': typeof GestorIndicacaoCancelarRoute
  '/gestor/indicacao/confirmar': typeof GestorIndicacaoConfirmarRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/gestor'
    | '/gestor/acessos'
    | '/gestor/camadas'
    | '/gestor/cargos'
    | '/gestor/confirmar-email'
    | '/gestor/conta'
    | '/gestor/conteudos'
    | '/gestor/esqueci-senha'
    | '/gestor/historico'
    | '/gestor/nova-senha'
    | '/gestor/painel'
    | '/gestor/senha'
    | '/gestor/'
    | '/gestor/esqueci-senha/codigo'
    | '/gestor/indicacao/cancelar'
    | '/gestor/indicacao/confirmar'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gestor/acessos'
    | '/gestor/camadas'
    | '/gestor/cargos'
    | '/gestor/confirmar-email'
    | '/gestor/conta'
    | '/gestor/conteudos'
    | '/gestor/esqueci-senha'
    | '/gestor/historico'
    | '/gestor/nova-senha'
    | '/gestor/painel'
    | '/gestor/senha'
    | '/gestor'
    | '/gestor/esqueci-senha/codigo'
    | '/gestor/indicacao/cancelar'
    | '/gestor/indicacao/confirmar'
  id:
    | '__root__'
    | '/'
    | '/gestor'
    | '/gestor/acessos'
    | '/gestor/camadas'
    | '/gestor/cargos'
    | '/gestor/confirmar-email'
    | '/gestor/conta'
    | '/gestor/conteudos'
    | '/gestor/esqueci-senha'
    | '/gestor/historico'
    | '/gestor/nova-senha'
    | '/gestor/painel'
    | '/gestor/senha'
    | '/gestor/'
    | '/gestor/esqueci-senha/codigo'
    | '/gestor/indicacao/cancelar'
    | '/gestor/indicacao/confirmar'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GestorRoute: typeof GestorRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor': {
      id: '/gestor'
      path: '/gestor'
      fullPath: '/gestor'
      preLoaderRoute: typeof GestorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestor/': {
      id: '/gestor/'
      path: '/'
      fullPath: '/gestor/'
      preLoaderRoute: typeof GestorIndexRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/acessos': {
      id: '/gestor/acessos'
      path: '/acessos'
      fullPath: '/gestor/acessos'
      preLoaderRoute: typeof GestorAcessosRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/camadas': {
      id: '/gestor/camadas'
      path: '/camadas'
      fullPath: '/gestor/camadas'
      preLoaderRoute: typeof GestorCamadasRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/cargos': {
      id: '/gestor/cargos'
      path: '/cargos'
      fullPath: '/gestor/cargos'
      preLoaderRoute: typeof GestorCargosRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/confirmar-email': {
      id: '/gestor/confirmar-email'
      path: '/confirmar-email'
      fullPath: '/gestor/confirmar-email'
      preLoaderRoute: typeof GestorConfirmarEmailRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/conta': {
      id: '/gestor/conta'
      path: '/conta'
      fullPath: '/gestor/conta'
      preLoaderRoute: typeof GestorContaRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/conteudos': {
      id: '/gestor/conteudos'
      path: '/conteudos'
      fullPath: '/gestor/conteudos'
      preLoaderRoute: typeof GestorConteudosRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/esqueci-senha': {
      id: '/gestor/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/gestor/esqueci-senha'
      preLoaderRoute: typeof GestorEsqueciSenhaRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/historico': {
      id: '/gestor/historico'
      path: '/historico'
      fullPath: '/gestor/historico'
      preLoaderRoute: typeof GestorHistoricoRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/nova-senha': {
      id: '/gestor/nova-senha'
      path: '/nova-senha'
      fullPath: '/gestor/nova-senha'
      preLoaderRoute: typeof GestorNovaSenhaRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/painel': {
      id: '/gestor/painel'
      path: '/painel'
      fullPath: '/gestor/painel'
      preLoaderRoute: typeof GestorPainelRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/senha': {
      id: '/gestor/senha'
      path: '/senha'
      fullPath: '/gestor/senha'
      preLoaderRoute: typeof GestorSenhaRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/esqueci-senha/codigo': {
      id: '/gestor/esqueci-senha/codigo'
      path: '/codigo'
      fullPath: '/gestor/esqueci-senha/codigo'
      preLoaderRoute: typeof GestorEsqueciSenhaCodigoRouteImport
      parentRoute: typeof GestorEsqueciSenhaRoute
    }
    '/gestor/indicacao/cancelar': {
      id: '/gestor/indicacao/cancelar'
      path: '/indicacao/cancelar'
      fullPath: '/gestor/indicacao/cancelar'
      preLoaderRoute: typeof GestorIndicacaoCancelarRouteImport
      parentRoute: typeof GestorRoute
    }
    '/gestor/indicacao/confirmar': {
      id: '/gestor/indicacao/confirmar'
      path: '/indicacao/confirmar'
      fullPath: '/gestor/indicacao/confirmar'
      preLoaderRoute: typeof GestorIndicacaoConfirmarRouteImport
      parentRoute: typeof GestorRoute
    }
  }
}

interface GestorEsqueciSenhaRouteChildren {
  GestorEsqueciSenhaCodigoRoute: typeof GestorEsqueciSenhaCodigoRoute
}

const GestorEsqueciSenhaRouteChildren: GestorEsqueciSenhaRouteChildren = {
  GestorEsqueciSenhaCodigoRoute: GestorEsqueciSenhaCodigoRoute,
}

const GestorEsqueciSenhaRouteWithChildren =
  GestorEsqueciSenhaRoute._addFileChildren(GestorEsqueciSenhaRouteChildren)

interface GestorRouteChildren {
  GestorAcessosRoute: typeof GestorAcessosRoute
  GestorCamadasRoute: typeof GestorCamadasRoute
  GestorCargosRoute: typeof GestorCargosRoute
  GestorConfirmarEmailRoute: typeof GestorConfirmarEmailRoute
  GestorContaRoute: typeof GestorContaRoute
  GestorConteudosRoute: typeof GestorConteudosRoute
  GestorEsqueciSenhaRoute: typeof GestorEsqueciSenhaRouteWithChildren
  GestorHistoricoRoute: typeof GestorHistoricoRoute
  GestorNovaSenhaRoute: typeof GestorNovaSenhaRoute
  GestorPainelRoute: typeof GestorPainelRoute
  GestorSenhaRoute: typeof GestorSenhaRoute
  GestorIndexRoute: typeof GestorIndexRoute
  GestorIndicacaoCancelarRoute: typeof GestorIndicacaoCancelarRoute
  GestorIndicacaoConfirmarRoute: typeof GestorIndicacaoConfirmarRoute
}

const GestorRouteChildren: GestorRouteChildren = {
  GestorAcessosRoute: GestorAcessosRoute,
  GestorCamadasRoute: GestorCamadasRoute,
  GestorCargosRoute: GestorCargosRoute,
  GestorConfirmarEmailRoute: GestorConfirmarEmailRoute,
  GestorContaRoute: GestorContaRoute,
  GestorConteudosRoute: GestorConteudosRoute,
  GestorEsqueciSenhaRoute: GestorEsqueciSenhaRouteWithChildren,
  GestorHistoricoRoute: GestorHistoricoRoute,
  GestorNovaSenhaRoute: GestorNovaSenhaRoute,
  GestorPainelRoute: GestorPainelRoute,
  GestorSenhaRoute: GestorSenhaRoute,
  GestorIndexRoute: GestorIndexRoute,
  GestorIndicacaoCancelarRoute: GestorIndicacaoCancelarRoute,
  GestorIndicacaoConfirmarRoute: GestorIndicacaoConfirmarRoute,
}

const GestorRouteWithChildren =
  GestorRoute._addFileChildren(GestorRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GestorRoute: GestorRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
